'use strict';

var React = require('react');

const SvgNone = ({ title, titleId, ...props }) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId }, props),
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { d: "M0 0h24v24H0z" })));

module.exports = SvgNone;
